import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UsersService } from 'src/app/services/users/users.service';
import { AffectOrgToUserModel } from 'src/app/models/affect-org-to-user.model';
import { lastValueFrom } from 'rxjs';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { Error } from 'src/app/models/error.model';
import { OrgModel } from 'src/app/models/org.model';

@Component({
  selector: 'app-role-delete-confirm-dialog',
  templateUrl: './role-delete-confirm.html',
  styleUrls: ['./role-delete-confirm.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class RoleDeleteConfirmComponent {
  selectedRole: OrgModel;
  isBusyDeleteRole = false;
  isError = false;
  isSuccess = false;
  error: Error = { error: { message: '', code: '' } };
  usertounassign: string;
  private userOidToUnassign: string;

  spinner = {
    color: 'primary',
    mode: 'indeterminate' as ProgressSpinnerMode,
    value: 50,
    diameter: 50,
  };

  constructor(
    public matDialogRef: MatDialogRef<RoleDeleteConfirmComponent>,
    @Inject(MAT_DIALOG_DATA)
    _data: {
      roletodelete: OrgModel;
      usertounassign: string;
      userOidToUnassign: string;
    },
    private _userService: UsersService
  ) {
    this.selectedRole = _data.roletodelete;
    this.usertounassign = _data.usertounassign;
    this.userOidToUnassign = _data.userOidToUnassign;
  }

  async deleteUser(): Promise<void> {
    try {
      const affectOrgToUser: AffectOrgToUserModel = {
        orgName: this.selectedRole.name,
        action: 'delete',
        userOids: [this.userOidToUnassign],
      };

      this.isSuccess = false;
      this.isBusyDeleteRole = true;

      await lastValueFrom(
        this._userService.AffectOrgToUsers(affectOrgToUser)
      ).then(() => {
        this.isBusyDeleteRole = false;
        this.isSuccess = true;
        this.matDialogRef.close(true);
      });
    } catch (error) {
      let customError: Error = { error: undefined };

      if (error.statusText == 'Unknown Error') {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      } else {
        if (error.error.errors) {
          customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
        } else {
          if (error.error) {
            customError = error.error;
          }
        }
        if (customError.error === undefined) {
          customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
        }
      }

      this.isError = true;
      this.error = customError;
      this.isBusyDeleteRole = false;
      this.isSuccess = false;
    } finally {
      /* empty */
    }
  }
}
